const OnboardingPage3Actions = {
  START_LOADING: 'ONBOARDING-START-LOADING',
  END_LOADING: 'ONBOARDING-END-LOADING',
  ONBOARDING_PROFILE_STEP: 'ONBOARDING_PROFILE_STEP',
  SET_PROFILE_DATA: 'SET_PROFILE_DATA',
  RESET_DATA: 'RESET_DATA'
};

export {
  OnboardingPage3Actions
};
